import React, { FC, ReactNode } from "react";
import { Grid } from "@mui/material";
import { Text } from "../Typography";

interface IInfoRow {
  heading: string;
  content: any;
  breakPoints?: any;
  sx?: object;
}

const initialValue = [{ xs: 3 }, { xs: 9 }];

export const InfoRow: FC<IInfoRow> = ({ heading, content, breakPoints = initialValue, sx }) => {
  return (
    <Grid container sx={sx} columnSpacing={2.5}>
      <Grid item {...breakPoints[0]}>
        <Text>{heading}</Text>
      </Grid>
      <Grid item {...breakPoints[1]}>
        <Text>{content}</Text>
      </Grid>
    </Grid>
  )
}